import React, { useReducer, useMemo } from 'react';
import PropTypes from 'prop-types';
import { SiteBuilder } from '@bingads-webui-campaign-react/smart-page-site-builder';
import {
  SiteConfigContext,
  siteConfigReducer,
  ClientContext,
  useIsSmartPageDarkModeEnabled,
  useIsM365Premium,
} from '@bingads-webui-campaign-react/smart-page-context';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { ThemeProvider } from 'react-jss';
import { SmartBanner } from '@bingads-webui-campaign-react/smart-component-banner';
import { getCurrentTheme, useResponsiveMode, getThemeConfigFromWSD } from '@bingads-webui-campaign-react/smart-component-util';

export const SmartPageRuntime = ({
  siteInfo,
  isRuntime,
}) => {
  const isM365Premium = useIsM365Premium();
  const isSmartPageDarkModeEnabled = useIsSmartPageDarkModeEnabled();
  const isDarkModeEnabled = isM365Premium && isSmartPageDarkModeEnabled;
  const [siteConfig, dispatchSiteConfig] = useReducer(siteConfigReducer, siteInfo);

  const componentRef = React.useRef();
  const { isMobile, responsiveMode } = useResponsiveMode(componentRef.current);

  const clientContext = {
    isMobile,
    responsiveMode,
    isRuntime,
  };

  const theme = useMemo(() => getCurrentTheme({
    themeConfig: isDarkModeEnabled && getThemeConfigFromWSD(siteConfig.websiteSourceData),
    isMobile,
  }), [isDarkModeEnabled, isMobile, siteConfig.websiteSourceData]);

  let background = '#edebe9';
  if (theme && theme.core && theme.core.palette) {
    const { core: { palette: { outerBackground } } } = theme;
    if (outerBackground) {
      background = outerBackground;
    }
  }

  return (
    <div
      className="smart-page-container"
      ref={componentRef}
      style={{ background }}
    >
      <SiteConfigContext.Provider
        value={{
          siteConfig,
          dispatchSiteConfig,
        }}
      >
        <I18nContext.Provider
          value={{
            getString: key => key,
          }}
        >
          <ClientContext.Provider value={clientContext} >
            <ThemeProvider theme={theme}>
              <SmartBanner />
              <SiteBuilder />
            </ThemeProvider>
          </ClientContext.Provider>
        </I18nContext.Provider>
      </SiteConfigContext.Provider>
    </div>
  );
};

SmartPageRuntime.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  siteInfo: PropTypes.object.isRequired,
  isRuntime: PropTypes.bool,
};

SmartPageRuntime.defaultProps = {
  isRuntime: false,
};
